"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
const lightingProjects = [{
  id: 1,
  title: "Romantic Uplighting",
  image: "https://denverweddingco.com/wp-content/uploads/2026/01/MG_6048-scaled.jpeg?v=e00nfnldh8"
}, {
  id: 2,
  title: "Modern Dance Floor",
  image: "https://denverweddingco.com/wp-content/uploads/2026/01/E3A7306-scaled.jpeg?v=8u8njhj533g"
}, {
  id: 3,
  title: "Elegant Ceiling Wash",
  image: "https://denverweddingco.com/wp-content/uploads/2026/01/Screenshot-2026-01-30-at-10.04.28-AM.png?v=9ek0nwimj9l"
}];
export default function LightingDesignGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="lighting-design-gallery" ref={ref} className="w-full bg-dark-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-4xl font-bold text-foreground-dark mb-4">
            Lighting Design Gallery
          </h2>
          <p className="text-foreground-dark/80 text-lg max-w-2xl mx-auto">
            Discover our professional lighting setups that transform your venue into an unforgettable celebration space
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {lightingProjects.map((project, i) => <Card key={project.id} data-index={i} className={`group relative overflow-hidden cursor-pointer bg-muted-dark-background hover-lift ${isVisible ? i === 0 ? "animate-fade-in-up" : i === 1 ? "animate-fade-in-up-delay-100" : i === 2 ? "animate-fade-in-up-delay-200" : "animate-fade-in-up" : "opacity-0"}`} style={isVisible && i > 2 ? {
          animationDelay: `${i * 100}ms`
        } : undefined}>
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={project.image} alt={project.title} className="w-full h-full object-cover transition-transform duration-[var(--duration-slow)] group-hover:scale-105" />
                
                <div className="absolute inset-0 bg-gradient-to-t from-dark-background/90 via-dark-background/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-[var(--duration-medium)]" />
                
                <div className="absolute bottom-0 left-0 right-0 px-6 py-4 translate-y-full group-hover:translate-y-0 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
                  
                </div>

                <div className="absolute inset-0 pointer-events-none opacity-0 group-active:opacity-100 transition-opacity duration-300">
                  <div className="absolute inset-0 bg-primary/20 rounded-full scale-0 group-active:scale-150 transition-transform duration-300 ease-out" style={{
                transformOrigin: "center"
              }} />
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}